<template>
  <label class="labels w-radio">
    <input
      class="w-form-formradioinput w-radio-input"
      type="radio"
      :checked="isChecked"
      :id="id"
      @input="$emit('update:modelValue', $event.target.id)"
    />
    <p class="paragraph">{{ value }}</p>
  </label>
</template>

<script>
export default {
  props: ["value", "id", "modelValue"],
  data: () => {
    return {}
  },
  created() {},
  computed: {
    isChecked() {
      this.$emit("update", true)
      return this.modelValue == this.id
    },
  },
}
</script>

<style scoped>
.paragraph {
  margin-left: 10%;
  margin-bottom: 0px;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
}

.labels {
  display: flex;
  align-items: center;
  height: 20px;
  cursor: pointer;
}
input {
  cursor: pointer;
}
</style>
